/**
 * Human-readable labels for payment provider / method enum codes on the
 * Payments tab mix chart.
 */
export function formatPaymentMixLabel(
  translate: (key: string, options?: Record<string, unknown>) => string,
  provider: string | null | undefined,
  method: string | null | undefined,
): string {
  const providerLabel = resolvePaymentCodeLabel(
    translate,
    'analytics.charts.paymentProviders',
    provider,
  );
  const methodLabel = resolvePaymentCodeLabel(
    translate,
    'analytics.charts.paymentMethods',
    method,
  );

  if (providerLabel && methodLabel && providerLabel !== methodLabel) {
    return `${providerLabel} · ${methodLabel}`;
  }
  if (providerLabel) {
    return providerLabel;
  }
  if (methodLabel) {
    return methodLabel;
  }
  return translate('analytics.charts.unknown');
}

function resolvePaymentCodeLabel(
  translate: (key: string, options?: Record<string, unknown>) => string,
  namespace: string,
  raw: string | null | undefined,
): string | null {
  if (raw == null) {
    return null;
  }
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return null;
  }
  const key = `${namespace}.${trimmed}`;
  const labeled = translate(key);
  if (labeled !== key) {
    return labeled;
  }
  return trimmed.replace(/_/g, ' ');
}
